module.exports = __webpack_public_path__ + "img/green-t3.d110c25f.png";